import React from "react";

const ChairIcon = ({ height = 14.064, width = 13.682 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13.682 14.064"
      >
        <path
          id="chair-solid"
          d="M3.4,3.516A2.164,2.164,0,0,1,4.619,1.623V7.032H6.085V1.319H7.551V7.032s1.1,1.352,1.466,0a25.744,25.744,0,0,0,0-5.409,2.164,2.164,0,0,1,1.222,1.893V7.032H11.7V3.516A3.728,3.728,0,0,0,7.8,0H5.841A3.728,3.728,0,0,0,1.931,3.516V7.032H3.4Zm10.21,5.876-.327-.879a.976.976,0,0,0-.928-.6H1.281a.976.976,0,0,0-.928.6l-.327.879a.9.9,0,0,0,.928,1.156v3.077a.467.467,0,0,0,.489.44H2.42a.467.467,0,0,0,.489-.44V10.548h7.819v3.077a.467.467,0,0,0,.489.44h.977a.467.467,0,0,0,.489-.44V10.548A.9.9,0,0,0,13.607,9.392Z"
          transform="translate(0.024)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default ChairIcon;
